module.exports = __webpack_public_path__ + "img/graph-dark.65ba7355.svg";